module.exports = __webpack_public_path__ + "static/media/fo.329cbed5.svg";